import { List } from "immutable"
import * as React from "react"
import { hyphen } from "../../../components/user_utils"
import * as DrupalModel from '../../../custom_models/drupal'
import { ParsedParagraphOpeningHours } from "../../../../Shared/api/drupal/types"
import { Container } from "../library/container"

export interface JumboProps {
  readonly headerTitle: string
  readonly pageTitle?: string
  readonly contents: string | JSX.Element
  readonly buttonUrl?: string
  readonly buttonTitle?: any
  readonly size: "small" | "large"
  readonly kind?: "default" | "home" | "home-location" | "activity" | "collection",
  readonly email?: string,
  readonly phoneNumber?: string,
  readonly address?: string,
  readonly openingHours?: List<ParsedParagraphOpeningHours>,
  readonly selectedLocationId?: string
  readonly branchLocations?: DrupalModel.Location[]
  readonly selectLocation?: (selectedId: string) => void
  readonly isFixed?: boolean
}

const renderContents = (contents: string | JSX.Element, htmlElement: JSX.Element, jsxElement: JSX.Element) => {
  return typeof contents == "string" ? (
    <htmlElement.type
      {...htmlElement.props}
      key={htmlElement.key}
      dangerouslySetInnerHTML={{ __html: contents }}
    />
  ) : (
      <jsxElement.type
        key={jsxElement.key}
        {...jsxElement.props}
      >
        {contents}
      </jsxElement.type>
    )
}

export const JumboKiosk = (props: JumboProps) => {
  const { size, kind, headerTitle, isFixed } = props
  const { contents } = props

  return size == "large" ?
    (
      <header className={`jumbotron jumbotron--kiosk jumbotron--large jumbotron--default${kind === 'collection' ? ' jumbotron--activity' : ''}`}>
        <Container className="jumbotron__inner">
          <div className="jumbotron__content">
            <h1 className="jumbotron__title title--xl">{hyphen(headerTitle)}</h1>

            {contents.toString().length > 0 &&
              <div className="jumbotron__intro">
                {contents.toString().length > 0 && (
                  renderContents(
                    contents,
                    <div />,
                    <div />
                  )
                )}

              </div>
            }
          </div>
        </Container>
      </header>
      ) : (
      <header className={`jumbotron jumbotron--kiosk jumbotron--small ${isFixed ? 'fixed' : ''}`}>
        <Container className="jumbotron__inner">
          <div className="jumbotron__content">
            <h1 className="jumbotron__title title--xl">{hyphen(headerTitle)}</h1>
          </div>
        </Container>
      </header>
    )
}
